import moment from 'moment';
import Text, { TEXT } from '~/view/components/Text/Text';
import { PromocodeLog } from '~/view/screens/PromocodeLogScreen/types';

type ListRowProps = {
  data: PromocodeLog;
};

const RowFiled = ({ text }: { text: string }) => {
  return (
    <div className="promocode-log-list-row__element">
      <Text dir="ltr" type={TEXT.LIST_ROW} text={text} noTranslate />
    </div>
  );
};

const PromocodeLogListRow = ({ data }: ListRowProps) => (
  <div className="promocode-log-list-row promocode-log-list-row__grid-template mr-4">
    <RowFiled text={moment(data.order_created_at).format('DD/MM/YYYY, h:mm A')} />
    <RowFiled text={data.promocode_name} />
    <RowFiled text={data.promocode_id.toString()} />
    <RowFiled text={data.promocode_discount.toString()} />
    <RowFiled text={data.order_reference} />
    <RowFiled text={data.promocode_value} />
    <RowFiled text={data.customer_phone} />
  </div>
);

export default PromocodeLogListRow;
